import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import { useViewerRoles } from '@treams/treams-hooks';
import { PageType } from '@treams/treams-network';
import { Announcement, Jumbo, Tabs } from '@treams/treams-ui';

import ManagerCalendar from './ManagerCalendar';
import { InboxManagerContainerWithoutSidebar } from './inbox/InboxManagerContainer';

export default function Manager() {
	const { t } = useTranslation();
	const { isWorkspaceSuperuser } = useViewerRoles();

	return (
		<>
			<Announcement />
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.Manager}
				title={t('manager.startpage.title')}
				description={t('manager.startpage.description')}
				footer={
					<Tabs.Container>
						<Tabs.Item title={t('manager.conversations.forecast.title')} path="/manager" />
						<Tabs.Item
							title={
								isWorkspaceSuperuser ? t('inbox.tab.superuser.title') : t('inbox.tab.manager.title')
							}
							path="/manager/inbox"
						/>
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route path="/manager" exact>
					<ManagerCalendar />
				</Route>
				<Route path="/manager/inbox" exact>
					<InboxManagerContainerWithoutSidebar header={false} />
				</Route>
			</Switch>
		</>
	);
}
